import { useMemo } from "react";
import { Form } from "antd";
import { useNumberParams } from "hooks/useNumberParams";
import { useEventTemplateDetailsQuery } from "@ticketingplatform/api/dist/recurringEvent/hooks";
import { EventType } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { EventTemplateFormValues } from "../RecuringEventForm/types";

import {
  UseEventTemplateDetails,
  UseEventTemplateDetailsReturnType,
} from "./types";
import { parseEventDataToFormValues } from "./utils";

export const useRecuringEventDetails: UseEventTemplateDetails = () => {
  const [form] = Form.useForm<EventTemplateFormValues>();
  const { id } = useNumberParams(true);
  const { data, loading } = useEventTemplateDetailsQuery({
    variables: {
      id,
      recurringSettingsInclude: true,
      venueInclude: false,
      imageInclude: true,
      seatMapInclude: true,
      ticketPoolsInclude: true,
      ticketPoolsTake: -1,
      presalePasswordsInclude: true,
      presalePasswordsTake: -1,
      discountCodesInclude: true,
      discountCodesTake: -1,
    },
  });

  return useMemo<UseEventTemplateDetailsReturnType>(
    () => ({
      loading,
      form: {
        initialValues: parseEventDataToFormValues(data),
        disabled: true,
        eventType: data?.eventTemplate?.type || EventType.TICKETED,
        eventStatus: data?.eventTemplate?.status,
        form,
      },
    }),
    [data, form, loading]
  );
};
